<template>
  <div class="contact-container">
    <!-- Overlay -->
    <div class="overlay" @click="$emit('close')"></div>

    <!-- Form Box -->
    <div class="contact-box p-4 p-md-5 rounded shadow-lg bg-white">
      <button type="button" class="close-btn" @click="$emit('close')" aria-label="Close">
        <i class="bi bi-x-lg"></i>
      </button>

      <div class="text-center mb-4">
        <div class="form-icon-badge">
          <i class="bi bi-envelope-paper-fill"></i>
        </div>
        <h3 class="fw-bold mt-3 mb-1">Get in Touch</h3>
        <p class="text-muted mb-0">We'd love to hear from you!</p>
      </div>

      <form @submit.prevent="handleSubmit">
        <div class="row g-3">
          <div class="col-md-6">
            <div class="input-icon-wrap">
              <i class="bi bi-person"></i>
              <input v-model="form.firstName" type="text" class="form-control form-control-lg"
                placeholder="First Name" required />
            </div>
          </div>

          <div class="col-md-6">
            <div class="input-icon-wrap">
              <i class="bi bi-person"></i>
              <input v-model="form.lastName" type="text" class="form-control form-control-lg"
                placeholder="Last Name" required />
            </div>
          </div>
        </div>

        <div class="mt-3 input-icon-wrap">
          <i class="bi bi-envelope"></i>
          <input v-model="form.email" type="email" class="form-control form-control-lg"
            placeholder="Email Address" required />
        </div>

        <div class="mt-3 input-icon-wrap">
          <i class="bi bi-telephone"></i>
          <input v-model="form.phoneNumber" type="tel" class="form-control form-control-lg"
            placeholder="Phone Number" required />
        </div>

        <div class="mt-3 input-icon-wrap textarea-icon-wrap">
          <i class="bi bi-chat-left-text"></i>
          <textarea v-model="form.message" rows="4" class="form-control form-control-lg"
            placeholder="Your Message" required></textarea>
        </div>

        <button class="btn btn-primary btn-lg w-100 mt-4" :disabled="loading">
          <span v-if="!loading">
            <i class="bi bi-send-fill me-2"></i>Send Message
          </span>
          <span v-else>
            <span class="spinner-border spinner-border-sm me-2"></span>Sending...
          </span>
        </button>

        <!-- Messages -->
        <transition name="fade">
          <p class="text-success fw-bold mt-3 mb-0" v-if="success">
            <i class="bi bi-check-circle-fill me-1"></i>{{ success }}
          </p>
        </transition>
        <transition name="fade">
          <p class="text-danger fw-bold mt-3 mb-0" v-if="error">
            <i class="bi bi-exclamation-circle-fill me-1"></i>{{ error }}
          </p>
        </transition>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_BASE_URL } from '@/utils/apis.js'
export default {
  name: "ContactUs",

  data() {
    return {
      form: {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        message: "",
      },
      success: "",
      error: "",
      loading: false,
    };
  },

  methods: {
    async handleSubmit() {
      this.success = "";
      this.error = "";
      this.loading = true;

      try {
        const res = await axios.post(`${API_BASE_URL}/Contact_querys/postcontactquery`, this.form);
        console.log(res);
        this.success = "Message sent successfully! 🎉";
        this.form = { firstName: "", lastName: "", email: "", phoneNumber: "", message: "" };
      } catch (err) {
        this.error = err?.response?.data?.message || "Something went wrong!";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
@import url(./ContactUs.css);
</style>